import { render, staticRenderFns } from "./addUser.vue?vue&type=template&id=f6c0d052&"
import script from "./addUser.vue?vue&type=script&lang=js&"
export * from "./addUser.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f6c0d052')) {
      api.createRecord('f6c0d052', component.options)
    } else {
      api.reload('f6c0d052', component.options)
    }
    module.hot.accept("./addUser.vue?vue&type=template&id=f6c0d052&", function () {
      api.rerender('f6c0d052', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/auth/users/components/addUser.vue"
export default component.exports